import logo from "./logo.png";
import background from "../new-header/background.jpg";
import { CampingRoute } from "../router/CampingRoute";
import { Menu } from "./Menu";
import { useLocation } from "react-router-dom";

export interface HeaderProps {
  pages: CampingRoute[];
}

export function Header({ pages }: HeaderProps) {
  const { pathname } = useLocation();
  const isHome = pathname === "/";

  return (
    <header className="relative overflow-hidden bg-emerald-950 text-white">
      <img
        src={background}
        alt=""
        aria-hidden
        className={`pointer-events-none absolute inset-0 h-full w-full object-cover transition-[filter,transform,opacity] duration-700 ease-out ${
          isHome
            ? "scale-100 blur-0 opacity-100"
            : "scale-110 blur-[2px] opacity-80"
        }`}
      />
      <div
        className={`pointer-events-none absolute inset-0 transition-all duration-700 ease-out ${
          isHome
            ? "bg-gradient-to-b from-[#0e2d18]/55 via-[#11341d]/65 to-[#102010]/90 backdrop-blur-0"
            : "bg-gradient-to-b from-[#0f1f14]/70 via-[#111f16]/78 to-[#102010]/94 backdrop-blur-xl"
        }`}
        aria-hidden
      />
      <div
        className={`relative mx-auto flex w-full max-w-7xl flex-col px-4 transition-[min-height] duration-700 ease-out sm:px-6 lg:px-8 ${
          isHome
            ? "min-h-[22rem] sm:min-h-[26rem] lg:min-h-[31rem]"
            : "min-h-[6rem] sm:min-h-[6.5rem] lg:min-h-[7.5rem]"
        }`}
      >
        <Menu pages={pages} isHome={isHome} />
        {isHome && (
          <div className="flex flex-1 flex-col items-center justify-center pb-8 pt-5 text-center sm:items-start sm:text-left">
            <img
              src={logo}
              alt="Camping des Îles"
              className="w-[14rem] opacity-100 drop-shadow-[0_8px_24px_rgba(0,0,0,0.45)] sm:w-[18rem] lg:w-[22rem]"
            />
            <p className="mt-4 max-w-2xl text-xs font-semibold uppercase tracking-[0.28em] text-amber-200/95 sm:text-sm">
              Camping familial au coeur de la Beauce
            </p>
            <h1 className="mt-3 max-w-2xl font-['Chewy'] text-3xl text-[#fff6dc] drop-shadow-[0_3px_8px_rgba(0,0,0,0.35)] sm:text-5xl">
              Nature, lac et feux de camp
            </h1>
            <p className="mt-3 max-w-xl text-sm text-emerald-100/95 sm:text-base">
              Profitez d&apos;un sejour tranquille au Lac des Iles avec vos
              proches.
            </p>
          </div>
        )}
      </div>
    </header>
  );
}
